export default __webpack_public_path__ + "static/media/blob1.4f14ba94.svg";